import { render, staticRenderFns } from "./RatingSummary.vue?vue&type=template&id=b190791c&scoped=true"
import script from "./RatingSummary.vue?vue&type=script&lang=js"
export * from "./RatingSummary.vue?vue&type=script&lang=js"
import style0 from "./RatingSummary.vue?vue&type=style&index=0&id=b190791c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b190791c",
  null
  
)

export default component.exports